import { combineReducers } from 'redux';
import auth from './auth';
import register from './register';
import admin from './admin';
import points from './points';

const rootReducer = combineReducers({ auth, register, admin, points });

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
